<template>
  <section
    :class="['home-page-airport-lounge', { 'use-card-item-style': options.useCardItemStyle }]"
  >
    <!-- 卡片顶层标题 -->
    <div class="card-head" :style="options.cardHeadStyle">
      <h3 role="title" v-if="options.title">{{ $t(options.title) }}</h3>
      <button
        v-if="options.subTitle"
        class="card-more"
        role="button"
        @click="handleViewMore(options.index)"
      >
        {{ $t(options.subTitle) }}
      </button>
    </div>

    <!-- 卡片图片及内容 -->
    <ul class="card-list">
      <li
        :class="['card-item', card.fakeElement ? 'card-item-fakeEle' : 'card-item-ele']"
        v-for="(card, index) in options.cards"
        :style="options.cardItemStyle"
        :key="index"
        @click="handleClickCard(card)"
      >
        <template v-if="!card.fakeElement">
          <div class="card-img">
            <!-- <div
              class="no-access-credit-card"
              v-if="
                card.type === '1' &&
                card.allowWriteOff !== undefined &&
                (!card.allowWriteOff || card.allowWriteOff === 'false')
              "
            >
              {{ $t('no-access-via-credit-card') }}
            </div> -->
            <img
              v-lazy="
                (card.imageUrl && card.imageUrl.length && card.imageUrl[0]) ||
                card.imgUrl ||
                card.coverImg
              "
              @error="onImgError"
              alt="Airport Lounge Image"
            />

            <div class="discount" v-if="options.showDiscount && card.freediscount">
              <p role="discount">{{ card.freediscount }}</p>
            </div>

            <div class="card-premium" v-if="showName">
              <p role="subtitle">{{ card.name }}</p>
            </div>
          </div>
          <div :class="['desc', { homePageFontSize: options.useHomePageSize }]">
            <p role="descriptions" :class="{ descriptionsOne: !!card.sname }">
              {{ card.sname }}
            </p>
            <p role="descriptions" :class="{ descriptionsTwo: options.showDesc2 }">
              {{ card.terminal || card.details
              }}<span v-if="card.inspection">, {{ card.inspection }}</span>
            </p>
            <p
              role="descriptions"
              class="lounge-tags"
              v-if="card.productType === '1' || card.productType === 1"
            >
              <span class="lounge-tag-label">
                <template v-if="showWalkInTag(card)">
                  <span>{{ $t('walkin') }}</span>
                  <span v-if="showPrebookTag(card)"> & {{ $t('prebook-title') }}</span>
                </template>
                <span v-else>{{ $t('prebook-title') }}</span>
              </span>
              <span
                v-if="isLogin && shouldShowAdditionalFeeIcon(card)"
                class="additional-fee-icon"
                :aria-label="$t('additional-entry-fee-applies')"
              >
                $
              </span>
            </p>
            <p
              role="descriptions"
              class="other-tags"
              v-if="
                card.tagList &&
                card.tagList.length > 0 &&
                (card.productType === '2' ||
                  card.productType === 2 ||
                  card.productType === '3' ||
                  card.productType === 3)
              "
            >
              <span v-for="tagItem in card.tagList">{{ tagItem }}</span>
            </p>
          </div>
        </template>
        <template v-else>
          <div></div>
        </template>
      </li>
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  const defaultImg = require('@/assets/images/defaultLounge.png');
  export default {
    name: 'AirportLoungeCard',

    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    computed: {
      ...mapState(['isLogin']),
    },

    data() {
      return {
        showName: this.options.showName ?? true,
      };
    },

    mounted() {},

    methods: {
      shouldShowAdditionalFeeIcon(card) {
        const { isShowPriceIcon, mtpUpgradeFeeAmount } = card;
        const hasUpgradeFeeAmount =
          mtpUpgradeFeeAmount !== null &&
          mtpUpgradeFeeAmount !== undefined &&
          mtpUpgradeFeeAmount !== '';

        return isShowPriceIcon === true && hasUpgradeFeeAmount;
      },
      // 标签规则: bookable 决定是否支持预定, prebookOnly 决定是否仅支持预定
      // bookable=false -> Walk-in
      // bookable=true + prebookOnly=1 -> Pre-book
      // bookable=true + prebookOnly=0 -> Walk-in & Pre-book
      // prebookOnly 兼容后端返回 number / string / boolean, 无法识别时返回 null
      getPrebookOnlyValue(card) {
        const value = card?.prebookOnly;
        if (value === 1 || value === '1' || value === true) return 1;
        if (value === 0 || value === '0' || value === false) return 0;
        return null;
      },
      // 是否支持预定
      isBookable(card) {
        return card?.bookable === true || card?.bookable === 'true';
      },
      // 是否展示 Walk-in 标签: 不支持预定时只展示 walk in
      showWalkInTag(card) {
        if (!this.isBookable(card)) return true;
        // 支持预定但仅支持预定时不展示 walk in
        return this.getPrebookOnlyValue(card) !== 1;
      },
      // 是否展示 Pre-book 标签: 支持预定时才展示
      showPrebookTag(card) {
        return this.isBookable(card);
      },
      handleViewMore(title) {
        this.$emit('viewMore', title);
        if (this.options.index === 'dining') {
          !!window.FS &&
            FS.event('Dining_Home', {
              timestamp: new Date().getTime(),
            });
        }
      },
      handleClickCard(card) {
        if (!card.fakeElement) {
          this.$emit('cardClick', card);
          if (this.options.index === 'dining') {
            !!window.FS &&
              FS.event('Dining_Home', {
                timestamp: new Date().getTime(),
              });
          }
        }
      },
      onImgError(e) {
        const img = e.srcElement;
        img.src = defaultImg;
        img.onerror = null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile.scss';
</style>
